export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.wim',
  },
  routes: [
    // WIM Data, WIM Dashboard, Reports (active)
    {
      name: 'wim',
      displayName: 'Traffic',
      meta: {
        icon: 'filter_list',
      },
      children: [
        {
          name: 'wim-dashboard',
          displayName: 'Dashboard',
          meta: {
            icon: 'dashboard',
          },
        },
        {
          name: 'wimdata',
          displayName: 'Data',
          meta: { icon: 'table_chart' },
        },
        {
          name: 'wim-reports',
          displayName: 'Reports',
          meta: { icon: 'assessment' },
        },
      ],
    },
    // --- Commented out ---
    // {
    //   name: 'watchdesk',
    //   displayName: 'Watchdesk',
    //   meta: {
    //     icon: 'dashboard',
    //   },
    //   children: [
    //     {
    //       name: 'watchdesk-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'watchdesk-reports',
    //       displayName: 'Combined Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'dashboard',
    //   displayName: 'Dashboard',
    //   meta: {
    //     icon: 'dashboard',
    //   },
    // },
    // {
    //   name: 'wim-speed',
    //   displayName: 'WIM Speed',
    //   meta: { icon: 'speed' },
    // },
    // {
    //   name: 'national-weighing',
    //   displayName: 'National Weighing',
    //   meta: {
    //     icon: 'scale',
    //   },
    //   children: [
    //     {
    //       name: 'multideck',
    //       displayName: 'Multideck',
    //       meta: {
    //         icon: 'view_agenda',
    //       },
    //     },
    //     {
    //       name: 'lswim',
    //       displayName: 'LSWIM',
    //       meta: { icon: 'speed' },
    //     },
    //     {
    //       name: 'mobile-weighing',
    //       displayName: 'Mobile Weighing',
    //       meta: { icon: 'local_shipping' },
    //     },
    //     {
    //       name: 'yard-management',
    //       displayName: 'Yard Management',
    //       meta: { icon: 'warehouse' },
    //     },
    //     {
    //       name: 'national-weighing-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'factory-weighing',
    //   displayName: 'Factory Weighing',
    //   meta: {
    //     icon: 'scale',
    //   },
    //   children: [
    //     {
    //       name: 'factory-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'factory-weigh',
    //       displayName: 'Weigh',
    //       meta: { icon: 'scale' },
    //     },
    //     {
    //       name: 'factory-mobile-weighing',
    //       displayName: 'Mobile Weighing',
    //       meta: { icon: 'local_shipping' },
    //     },
    //     {
    //       name: 'factory-records',
    //       displayName: 'Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'kiosk-weigh',
    //       displayName: 'Kiosk Mode',
    //       meta: { icon: 'tv' },
    //     },
    //     {
    //       name: 'factory-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'vehicle-inspection',
    //   displayName: 'Vehicle Inspection',
    //   meta: {
    //     icon: 'car_repair',
    //   },
    //   children: [
    //     {
    //       name: 'inspection-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'inspection-records',
    //       displayName: 'Inspected Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'inspection-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'parking',
    //   displayName: 'Parking',
    //   meta: {
    //     icon: 'local_parking',
    //   },
    //   children: [
    //     {
    //       name: 'parking-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'parking-records',
    //       displayName: 'Parking Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'parking-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'tags',
    //   displayName: 'Tags',
    //   meta: {
    //     icon: 'tag',
    //   },
    //   children: [
    //     {
    //       name: 'tags-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'tags-records',
    //       displayName: 'Tag Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'tags-management',
    //       displayName: 'Tag Management',
    //       meta: { icon: 'settings' },
    //     },
    //     {
    //       name: 'tags-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'traffic-census',
    //   displayName: 'Traffic Census',
    //   meta: {
    //     icon: 'traffic',
    //   },
    //   children: [
    //     {
    //       name: 'census-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'census-records',
    //       displayName: 'Census Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'census-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'calibration',
    //   displayName: 'Calibration',
    //   meta: {
    //     icon: 'tune',
    //   },
    //   children: [
    //     {
    //       name: 'calibration-dashboard',
    //       displayName: 'Calibration Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'calibration-records',
    //       displayName: 'Records',
    //       meta: { icon: 'history' },
    //     },
    //   ],
    // },
    // {
    //   name: 'tolling',
    //   displayName: 'Tolling',
    //   meta: {
    //     icon: 'payments',
    //   },
    //   children: [
    //     {
    //       name: 'tolling-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'tolling-records',
    //       displayName: 'Toll Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'tolling-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'prosecution',
    //   displayName: 'Prosecution',
    //   meta: {
    //     icon: 'gavel',
    //   },
    //   children: [
    //     {
    //       name: 'prosecution-dashboard',
    //       displayName: 'Dashboard',
    //       meta: {
    //         icon: 'dashboard',
    //       },
    //     },
    //     {
    //       name: 'prosecution-records',
    //       displayName: 'Prosecution Records',
    //       meta: { icon: 'history' },
    //     },
    //     {
    //       name: 'prosecution-reports',
    //       displayName: 'Reports',
    //       meta: { icon: 'assessment' },
    //     },
    //   ],
    // },
    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
